// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"Ynf5Qz","input":"VKbJi4"};